import styled from 'styled-components';
import { fromTheme } from 'src/styles/theme';
import { media } from 'src/styles/designs';

export const AboutUsHeading = styled.h1`
  font-size: 24px;
  line-height: 29px;
  font-weight: 300;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${fromTheme((theme) => theme.palette.accent)};

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 32px;
    line-height: 36px;
  }
`;
